import Immutable from 'immutable';

export function toImmutable<T>(object: T | DeepIMap<T>): DeepIMap<T> {
  // @ts-expect-error: some immutable types are missing
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return Immutable.isImmutable(object) ? object : Immutable.fromJS(object);
}
